import { Route } from 'react-router-dom';
import { OperatorList } from './list';

export const OperatorsRoute = (
  <Route path="operators">
    <Route index element={<OperatorList />} />
  </Route>
);
